import React, { useEffect } from 'react';
import { useSearch, useNavigate } from '@tanstack/react-router';

export default function IqcCreatePage() {
  const search = useSearch({ strict: false }) as { poId?: string; purchaseOrderId?: string };
  const navigate = useNavigate();

  useEffect(() => {
    navigate({
      to: "/qc-materials/create" as any,
      search: {
        purchaseOrderId: search.poId || search.purchaseOrderId,
      },
      replace: true,
    });
  }, [navigate, search]);

  return (
    <div className="p-8 text-center text-slate-500">
      Đang chuyển tiếp đến biểu mẫu Tiếp nhận IQC...
    </div>
  );
}
